<template>
  <div class="stationery-record">
    <stationeryRecordTopbar v-model="currentCourseIndex" :statusList="statusList" :currentLabel="currentLabel"
      @currentContentIndex="currentContentIndex" @searchTeacherName="teacherNameSearch"
      @isAddStationeryRecordShowSwitch="isAddStationeryRecordShowSwitch" @stationeryNameSearch="stationeryNameSearch"
      @applyDateChange="applyDateChange" />
    <div class="stationeryRecord-main">
      <stationeryRecordContentItem v-for="(item, index) in statusList" :key="index" :currentLabel="currentLabel"
        :isCurrentContentItem="currentCourseIndex == index" :currentStatus="statusList[currentCourseIndex].value"
        :changeStatus="changeStatus" :searchTeacherName="searchTeacherName" :searchStationeryName="searchStationeryName"
        @revocation="revocation" :stationeryRecordList="stationeryRecordList" :stationeryList="stationeryList"
        :date="date" />
    </div>
    <stationeryRecordAdd :dialogFormVisible.sync="isAddStationeryRecordShow" v-show="isAddStationeryRecordShow"
      @addStationeryRecord="addStationeryRecord" :stationeryList="stationeryList" />
  </div>
</template>

<script>
import stationeryRecordTopbar from "./components/stationeryRecord-topbar/stationeryRecord-topbar.vue";
import stationeryRecordContentItem from "./components/stationeryRecord-content-item/stationeryRecord-content-item.vue";
import stationeryRecordAdd from "./components/stationeryRecord-add/stationeryRecordAdd.vue";

export default {
  data() {
    return {
      currentCourseIndex: 0,
      changeStatus: 0,
      searchTeacherName: "",
      searchStationeryName: "",
      statusList: [
        {
          label: "待审批",
          value: 0,
        },
        {
          label: "审批通过",
          value: 1,
        },
        {
          label: "审批拒绝",
          value: 2,
        },
        {
          label: "申请统计",
          value: 3,
        },
        {
          label: "我的申请",
          value: 4,
        },
      ],
      stationeryRecordDetail: {},
      detailShow: false,
      isAddStationeryRecordShow: false,
      stationeryRecordList: [], // 审核记录
      stationeryList: [], // 学校文具列表
      date: '', // 日期区间
      currentLabel: ''
    };
  },
  components: {
    stationeryRecordTopbar,
    stationeryRecordContentItem,
    stationeryRecordAdd,
  },
  created() {
    // 一次性获取并解析权限列表
    const menuPermissions = window.localStorage.getItem("menuPermissions").split(',');

    // 定义需要检查的权限及其对应的过滤条件
    const authorityFilters = [
      { authority: 'sc:stationeryrecord:audit', filterOut: ["待审批", "审批通过", "审批拒绝"] },
      { authority: 'sc:stationeryrecord:statistics', filterOut: ["申请统计"] },
      { authority: 'sc:stationeryrecord:mylist', filterOut: ["我的申请"] }
    ];

    // 应用所有权限相关的过滤条件
    this.statusList = this.statusList.filter(item =>
      authorityFilters.every(filter =>
        menuPermissions.includes(filter.authority) || !filter.filterOut.includes(item.label)
      )
    );

    // 重新赋值 value 属性
    this.statusList = this.statusList.map((item, index) => ({ ...item, value: index }));

    // 设置当前选中的标签为过滤后列表的第一个元素的标签
    this.currentLabel = this.statusList[0] ? this.statusList[0].label : null;

    // 获取文具列表
    this.getStationeryList();
  },
  methods: {
    getStationeryList() {
      // this.getListResult = "loading";
      this.get(this.$url.selectSchoolStationeryList).then((res) => {
        // console.log("查询学校文具列表==>", res);
        if (res.code !== 200) return;
        this.stationeryList = res.rows;
      });
    },
    isAddStationeryRecordShowSwitch(e) {
      this.isAddStationeryRecordShow = e;
    },
    revocation(e) {
      this.changeStatus = e;
    },
    // 搜索词(接受topBar传来的值)
    teacherNameSearch(e) {
      // 搜索词改变时才赋值
      if (this.searchTeacherName != e) {
        this.searchTeacherName = e;
      }
    },
    stationeryNameSearch(e) {
      // 搜索词改变时才赋值
      if (this.searchStationeryName != e) {
        this.searchStationeryName = e;
      }
    },
    applyDateChange(date) {
      this.date = date;
    },
    // 当前选中状态下标
    currentContentIndex(e) {
      this.currentLabel = this.statusList[e].label;
      this.currentCourseIndex = e;
    },
    addStationeryRecord(e) {
      this.changeStatus = e;
    },
    getstationeryRecordList() {
      this.get(
        this.$url.getstationeryRecordList + "?schoolId=" + this.user.schoolId
      ).then((res) => {
        // console.log("场馆列表==>", res);
        this.stationeryRecordList = res.rows;
        this.isAddStationeryRecordShow = true;
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "./stationeryRecord.scss";
</style>